import { IStore } from '../../index'

function getScrollTop(state: IStore) {
  return state.bookingCalendar.scrollTop
}

function getScrollDragging(state: IStore) {
  return state.bookingCalendar.scrollIsDragging
}

export default getScrollTop

export { getScrollDragging, getScrollTop }
